import classnames from 'classnames';
import isEqual from 'lodash/isEqual';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { zip } from 'rxjs';
import { take } from 'rxjs/operators';
import AppPropTypes from '../../proptypes/AppPropTypes';
import withSubscription from '../withSubscriptions/withSubscriptions';

import Input from './Input';
import Table from './Table';
import Spinner from '../spinner/Spinner';

export const variants = {
  input: <Input />,
  spinner: <Spinner />,
  table: <Table />
};
export class PlaceResolverComponent extends Component {
  static defaultProps = {
    className: '',
    classes: {},
    setSubscriptions() {},
    variant: ''
  };

  static propTypes = {
    className: PropTypes.string,
    classes: AppPropTypes.jssClasses,
    children: PropTypes.func.isRequired,
    services: PropTypes.arrayOf(PropTypes.func).isRequired,
    setSubscriptions: PropTypes.func,
    variant: PropTypes.element
  };

  state = {
    loading: true,
    results: [],
    lastSync: null,
    reloads: [],
    syncTimes: [],
    subscriptions: null
  };

  componentDidMount() {
    this.fetchAllServices();
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(this.props.services, prevProps.services)) {
      this.refetchAllServices({});
    }
  }

  componentWillUnmount() {
    const { subscriptions } = this.state;
    if (subscriptions && subscriptions.unsubscribe) subscriptions.unsubscribe();
  }

  fetchService = (service, serviceIndex) => (props, loading) => {
    const service$ = service(props).pipe(take(1));

    this.setState(
      {
        loading: Boolean(loading)
      },
      () => {
        const reserviceSub = service$.subscribe((newResult) => {
          this.setState((state) => ({
            results: state.results.map((result, index) =>
              serviceIndex === index ? newResult : result
            ),
            syncTimes: state.syncTimes.map((time, index) =>
              serviceIndex === index ? moment() : time
            ),
            lastSync: moment(),

            loading: false
          }));
        });
        this.props.setSubscriptions({ reserviceSub });
      }
    );

    return service$;
  };

  fetchAllServices = () => {
    const allServicesSub = zip(...this.props.services.map((service) => service()))
      .pipe(take(1))
      .subscribe((results) =>
        this.setState({
          results,
          loading: false,
          lastSync: moment(),
          reloads: this.props.services.map((service, index) => this.fetchService(service, index)),
          syncTimes: this.props.services.map(() => moment())
        })
      );
    this.props.setSubscriptions({ allServicesSub });
    this.setState({ subscriptions: allServicesSub });
  };

  refetchAllServices = ({ loading }) => {
    this.setState(
      {
        loading: Boolean(loading)
      },
      this.fetchAllServices
    );
  };

  render() {
    const isIE = /* @cc_on!@ */ false || !!document.documentMode;
    const isEdge = !isIE && !!window.StyleMedia;

    const { lastSync, loading, reloads, results, syncTimes } = this.state;
    const {
      className,
      classes: { hideContent, hideSkeleton },
      variant
    } = this.props;

    let placeholder = variant || null;
    if (variant && (isIE || isEdge)) {
      placeholder = variants.spinner;
    }

    return (
      <>
        <div
          className={classnames({ [hideContent]: loading, [hideSkeleton]: !loading }, className)}
          data-loading={loading}
        >
          {(!loading && results.length) || (loading && !placeholder) ? (
            <>
              {this.props.children({
                results,
                reload: this.refetchAllServices,
                reloads,
                lastSync,
                loading,
                syncTimes
              })}
            </>
          ) : (
            <span data-qa="placeholder">{placeholder}</span>
          )}
        </div>
      </>
    );
  }
}

const Subbed = withSubscription(PlaceResolverComponent);
export default Subbed;
